"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOffersMockParameterToJSON = exports.GetOffersMockParameterFromJSONTyped = exports.GetOffersMockParameterFromJSON = exports.instanceOfGetOffersMockParameter = void 0;
/**
 * Check if a given object implements the GetOffersMockParameter interface.
 */
function instanceOfGetOffersMockParameter(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetOffersMockParameter = instanceOfGetOffersMockParameter;
function GetOffersMockParameterFromJSON(json) {
    return GetOffersMockParameterFromJSONTyped(json, false);
}
exports.GetOffersMockParameterFromJSON = GetOffersMockParameterFromJSON;
function GetOffersMockParameterFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetOffersMockParameterFromJSONTyped = GetOffersMockParameterFromJSONTyped;
function GetOffersMockParameterToJSON(value) {
    return value;
}
exports.GetOffersMockParameterToJSON = GetOffersMockParameterToJSON;
